import React from 'react';
import './HnWTooltip.scss'

export default function HnWTooltip ({ children }) {
    return (
        <div className="hnw-tooltip-container">
            {children}
        </div>
    )
}